var _defs, _line, _polyline, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".download-1,.download-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:5px;}.download-1{stroke-miterlimit:10;}.download-2{stroke-linejoin:round;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "5px",
    strokeMiterlimit: 10,
    x1: 35.5,
    x2: 35.5,
    y1: 18.5,
    y2: 48.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "5px",
    strokeLinejoin: "round",
    transform: "translate(-14.16 -14.7)",
    points: "57.8 59.11 49.93 66.98 42.2 59.25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "5px",
    strokeMiterlimit: 10,
    cx: 35.5,
    cy: 35.5,
    r: 33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7ab39299.svg";
export { ForwardRef as ReactComponent };